
import { useOptimizedAuth } from "@/hooks/useOptimizedAuth";
import { Navigate } from "react-router-dom";
import Header from '@/components/header/ModernHeader';
import Footer from "@/components/Footer";
import ErrorBoundary from "@/components/ErrorBoundary";

const Dashboard = () => {
  const { user, loading } = useOptimizedAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-gray-900 mx-auto"></div>
          <p className="mt-4 text-gray-600 font-light">Loading dashboard...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  return (
    <ErrorBoundary>
      <div className="min-h-screen bg-gray-50">
        <Header />
        <div className="container mx-auto px-4 py-8">
          <div className="max-w-6xl mx-auto">
            <h1 className="text-3xl font-bold text-gray-900 mb-8">Dashboard</h1>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              <div className="bg-white rounded-lg shadow p-6">
                <h3 className="text-lg font-medium text-gray-900 mb-4">Profile</h3>
                <p className="text-gray-600 mb-4">Manage your account settings and personal information</p>
                <a
                  href="/profile"
                  className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                >
                  View Profile
                </a>
              </div>

              <div className="bg-white rounded-lg shadow p-6">
                <h3 className="text-lg font-medium text-gray-900 mb-4">Orders</h3>
                <p className="text-gray-600 mb-4">Track your orders and view order history</p>
                <a
                  href="/orders"
                  className="inline-flex items-center px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700"
                >
                  View Orders
                </a>
              </div>

              <div className="bg-white rounded-lg shadow p-6">
                <h3 className="text-lg font-medium text-gray-900 mb-4">Wishlist</h3>
                <p className="text-gray-600 mb-4">View and manage your saved items</p>
                <a
                  href="/wishlist"
                  className="inline-flex items-center px-4 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700"
                >
                  View Wishlist
                </a>
              </div>

              <div className="bg-white rounded-lg shadow p-6">
                <h3 className="text-lg font-medium text-gray-900 mb-4">Settings</h3>
                <p className="text-gray-600 mb-4">Configure your account preferences and settings</p>
                <a
                  href="/settings"
                  className="inline-flex items-center px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700"
                >
                  View Settings
                </a>
              </div>

              <div className="bg-white rounded-lg shadow p-6">
                <h3 className="text-lg font-medium text-gray-900 mb-4">Addresses</h3>
                <p className="text-gray-600 mb-4">Manage your shipping and billing addresses</p>
                <a
                  href="/addresses"
                  className="inline-flex items-center px-4 py-2 bg-orange-600 text-white rounded-md hover:bg-orange-700"
                >
                  Manage Addresses
                </a>
              </div>

              <div className="bg-white rounded-lg shadow p-6">
                <h3 className="text-lg font-medium text-gray-900 mb-4">Browse Products</h3>
                <p className="text-gray-600 mb-4">Discover new products and add them to your cart</p>
                <a
                  href="/products"
                  className="inline-flex items-center px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
                >
                  Browse Products
                </a>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </ErrorBoundary>
  );
};

export default Dashboard;
